<template>
  <VDialogV3
    id="offer-card"
    position="right"
    width="600px"
    height="100vh"

    :tabs="tabs"
    :active-tab="activeTab"
    @update:active-tab="tab => activeTab = tab"

    :context-menu="OffersService.contextMenu"
    :entity="localOffer"
  >
    <OfferMainSection
      v-if="activeTab.id === 'main'"
      :offer="localOffer"
    />

    <OfferCharacteristicsSection
      v-if="activeTab.id === 'characteristic'"
      :offer="localOffer"
    />

    <template #footer>
      <VButton
        v-if="$core.currentPartner.isBuyer"
        theme="primary"
        :disabled="isDisabledBuyOneClick"
        :title="disabledActionText"
        @click="showOrderCreateDialogMinimized"
      >
        Создать заказ
      </VButton>
      <VButton @click="$core.dialogs.OfferCard.resolve()">
        Закрыть
      </VButton>
    </template>
  </VDialogV3>
</template>

<style lang="scss" src="./OfferCard.scss"/>

<script lang="ts">

import OfferCharacteristicsSection from '@/domains/Offers/components/OfferCard/OfferCharacteristicsSection.vue';
import OfferMainSection            from '@/domains/Offers/components/OfferCard/OfferMainSection.vue';
import OffersService               from '@/domains/Offers/OffersService';
import type Offer                  from '@/domains/Offers/Offer';
import type Tender                 from '@/domains/Tenders/Tender';

export default defineComponent({
  name: 'OfferCard',

  components: {
    OfferCharacteristicsSection,
    OfferMainSection,
  },

  props: {
    id: {
      type:    Number,
      default: null,
    },
    offer: {
      type:    Object as PropType<Offer>,
      default: null,
    },
    tender: {
      type:    Object as PropType<Tender>,
      default: null,
    },
  },

  data() {
    return {
      OffersService,

      localOffer: null as Offer | null,
      activeTab:  { id: 'main', name: 'Основное' },
      tabs: [
        {
          id:   'main',
          name: 'Основное',
        },
        {
          id:   'characteristic',
          name: 'Характеристики',
        },
      ],
    };
  },

  computed: {
    isDisabledBuyOneClick(): boolean {
      if (this.tender?.isRunning) {
        return true;
      }
      else {
        return this.localOffer?.qty <= 0;
      }
    },

    disabledActionText(): string | null {
      if (this.tender?.isRunning) {
        return 'Тендер ещё не окончен';
      }
      else if (this.localOffer?.qty <= 0) {
        return 'Предложение исчерпано';
      }
      else {
        return null;
      }
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id || this.offer) {
        this.localOffer = await OffersService.get(this.id || this.offer.id);
      }
    },

    showOrderCreateDialogMinimized(): void {
      OffersService.showOrderCreateDialogMinimized(this.localOffer, this.tender);
    },
  },
});

</script>
